// extracted by mini-css-extract-plugin
var _1 = "AdminBillingView-module__contentWrapper--u7q0Y";
export { _1 as "contentWrapper" }
